import { FC, PropsWithChildren } from 'react';

import styles from 'bloko/blocks/form/form.less';

const FormRequired: FC<PropsWithChildren> = ({ ...formRequiredProps }) => {
    return <span {...formRequiredProps} className={styles['bloko-form-required']} />;
};

export default FormRequired;
